export default {
    enable: {
        type: Boolean,
        default: undefined
    },
    index: {
        type: Number,
        default: undefined
    },
    selection: {
        type: String,
        default: undefined
    },

    // Events
    select: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-vue-wrapper/src/KendoButtonGroup/ButtonGroupProps.js